import { render } from "./AppTopBar.vue?vue&type=template&id=b5e8cf32"
import script from "./AppTopBar.vue?vue&type=script&lang=js"
export * from "./AppTopBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__